;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { QueryClient } from "@tanstack/react-query";
import { clientInvalidationEventSchema } from "@/lib/client-invalidation/event-schema";
import { queryKeysForEvent } from "@/lib/client-invalidation/query-keys-for-event";

export function invalidateQueriesForEventPayload(input: {
	payload: string;
	queryClient: QueryClient;
}): void {
	let parsedJson: unknown;
	try {
		parsedJson = JSON.parse(input.payload);
	} catch {
		return;
	}

	const parsedEvent = clientInvalidationEventSchema.safeParse(parsedJson);
	if (!parsedEvent.success) {
		return;
	}

	for (const queryKey of queryKeysForEvent(parsedEvent.data)) {
		void input.queryClient.invalidateQueries({ queryKey });
	}
}
